module.exports = __webpack_public_path__ + "img/c08_unittechramchampion_Normal_ua.e2238e4e.webp";